import { ReactNode, FC, createContext, useState, useMemo } from 'react';
import { getToken } from '@helpers/utils';
const AuthContext = createContext<any>({});

type AuthProps = {
  children: ReactNode;
};

const Auth: FC<AuthProps> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getToken());

  const authProviderValue = useMemo(
    () => ({ isLoggedIn, setIsLoggedIn }),
    [isLoggedIn, setIsLoggedIn],
  );

  return (
    <AuthContext.Provider value={authProviderValue}>
      {children}
    </AuthContext.Provider>
  );
};

export { Auth, AuthContext };
